import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  details: {
    defaultMessage: 'Details',
    id: 'Alert.details',
  },
  errorReason: {
    defaultMessage: 'Error reason',
    id: 'Alert.errorReason',
  },
  errorTrackingId: {
    defaultMessage: 'Tracking ID',
    id: 'Alert.errorTrackingId',
  },
  errorType: {
    defaultMessage: 'Error type',
    id: 'Alert.errorType',
  },
  errorStatus: {
    defaultMessage: 'Error status',
    id: 'Alert.errorStatus',
  },
  provider: {
    defaultMessage: 'Provider',
    id: 'Alert.errorProvider',
  },
  paymentRequestId: {
    defaultMessage: 'Payment request ID',
    id: 'Alert.errorPaymentRequestId',
  },
});
